<template>
  <div class="knowledge-wrap">
    <div class="layout">
    <Layout>
      <Header>
        <Input @on-enter="getQaList(1, false)" v-model="keyword">
            <Select slot="prepend" style="width: 80px">
                <Option value="day">搜索内容</Option>
            </Select>
            <Button @click="getQaList(1, false)" slot="append" icon="ios-search"></Button>
        </Input>
      </Header>
      <Layout>
        <div style="text-align: left;padding: 5px 20px;cursor: pointer;">        
          <span @click="recordModal = true" style="color: #3c8dbc;">添加记录</span>
        </div>
      </Layout>
      
    <Layout>
        <Sider style="background: #fff;" width="240" hide-trigger>
          <Row style="background: #fff;">
            <Col span="12">
              <Input search enter-button v-model="cateKeyword" @on-search="getKnowCate" @on-enter="getKnowCate" placeholder="输入后回车搜索" style="width: 240px;">
              </Input>
            </Col>
          </Row>
          <Row style="background: #fff;padding: 10px;">
              <Col span="12">
                  <Button type="dashed" long @click="addCateModal = true" icon="md-add">添加分类</Button>
              </Col>
          </Row>
          <Menu active-name="1">
            <div style="max-height: 800px;overflow-y: scroll;">
           <MenuItem @mouseenter.native="hoverCate(index)" @mouseleave.native="hoveroutCate(index)" style="position: relative;" @click.native="selectCate(cate)" v-for="(cate, index) in cateList" :key="index" :name="index">
               {{cate.product_sku}}
               <div v-show="cate.show == true" class="cate-tool">
                 <Icon style="cursor: pointer;" @click="editCate(cate)" :size="20" type="md-create" />
                 <Icon style="cursor: pointer;" @click="delCate(cate)" :size="20" type="ios-trash" />
               </div>
           </MenuItem>
           </div>
          </Menu>
        </Sider>
        <Layout>
            <Content>
            <Scroll :height="800" :on-reach-bottom="getMore">
                <div @click="addModal = true" class="add-btn">
                  <Icon type="md-add" />
                </div>
                <List>
                  <ListItem v-for="(item, index) in qaList" :key="index">
                    <div class="qa-wrap">
                      
                      <div class="question-wrap">
                        <span class="label-wrap">Q: </span>
                        <span class="question-val">{{item.questions}}</span>
                      </div>
                      <div class="answer-wrap">
                        <span class="label-wrap">A: </span>
                        <span class="answer-val" v-html="item.answers"></span>
                      </div>
                      <div class="tools">
                        <span class="editor-tool">
                          <Icon style="cursor: pointer;" @click="editKnow(item)" :size="20" type="md-create" />
                          <Icon style="cursor: pointer;" @click="delKnow(item)" :size="20" type="ios-trash" />
                        </span>
                        <span class="copy-tool">                        
                          <Icon style="cursor: pointer;" @click="onCopy(item)" :size="20" type="md-copy" />
                        </span>
                      </div>
                    </div>
                  </ListItem>
                </List>
                <Empty :load="load"></Empty>
            </Scroll>
            </Content>
        </Layout>
    </Layout>
  </Layout>
    </div>
    <Modal 
        v-model="addModal"
        title="添加"
        width="500"
        @on-ok="addKnowledge()"
        >
        <Form :model="formItem" :label-width="80">
          <FormItem label="分类">
            <Select v-model="formItem.cate_id">
                <Option v-for="(cate, index) in cateList" :key="index" :value="cate.id">{{cate.product_sku}}</Option>
            </Select>
        </FormItem>
          <FormItem label="问题">
              <Input v-model="formItem.question" placeholder="请输入问题"></Input>
          </FormItem>
          <FormItem label="回答">
            
            <EditorTool toref="knowEditor" ref="answerAddElem"></EditorTool>

        </FormItem>
        </Form>
    </Modal>
    <Modal 
        v-model="editModal"
        title="编辑"
        width="500"
        @on-ok="editKnowledge()"
        >
        <Form :model="editFormItem" :label-width="80">
          <FormItem label="分类">
            <Select v-model="editFormItem.cate_id">
                <Option v-for="(cate, index) in cateList" :key="index" :value="cate.id">{{cate.product_sku}}</Option>
            </Select>
        </FormItem>
          <FormItem label="问题">
              <Input v-model="editFormItem.question" placeholder="请输入问题"></Input>
          </FormItem>
          <FormItem label="回答">
            <EditorTool toref="knowEditEditor" ref="answerEditorElem"></EditorTool>
            
        </FormItem>
        </Form>
    </Modal>
    <Modal 
        v-model="addCateModal"
        title="添加分类"
        width="500"
        @on-ok="addCate()"
        >
        <Form :model="formItem" :label-width="80">
          <FormItem label="分类">
              <Input v-model="formItem.cateName" placeholder="请输入分类名"></Input>
          </FormItem>
        </Form>
    </Modal>
    <Modal 
        v-model="editCateModal"
        title="编辑分类"
        width="500"
        @on-ok="editCateRequest()"
        >
        <Form :model="editCateFormItem" :label-width="80">
          <FormItem label="分类">
              <Input v-model="editCateFormItem.cateName" placeholder="请输入分类名"></Input>
          </FormItem>
        </Form>
    </Modal>
    <Modal 
        v-model="recordModal"
        title="问题添加记录"
        width="800"
        :footer-hide="true"
        >
        <Addrecord></Addrecord>
    </Modal>
  </div>
</template>
<script>
import conf from "../conf";
import RequestUtils from "../../../utils/RequestUtils";
import Empty from "./empty.vue";
import Addrecord from "./knowledge/addrecord.vue";
import EditorTool from './common/editorTool';

export default {
  name: "faces",
  components: {
    Empty,
    Addrecord,
    EditorTool
  },
  props: {
      //内容
      value: {
          type: String,
          default: ''
      },
      //是否禁用
      disabled: {
          type: Boolean,
          default: false
      },
      triggerChange: {
          type: Boolean,
          default: false,
          required: false
      },
      //插件
      plugins: {
          type: [String, Array],
          default: () => ['link', 'preview', 'paste']
      }
  },
  data() {
    return {
      cateList: [],
      qaList: [],
      pageParam: {},
      activeCate: {},
      keyword: '',
      cateKeyword: '',
      load: 1,
      addModal: false,
      editModal: false,
      editCateModal: false,
      addCateModal: false,
      recordModal: false,
      formItem: {
        question: '',
        answer: '',
        cateName: ''
      },
      editFormItem: {
        question: '',
        answer: '',
        cate_id: ''
      },
      editCateFormItem: {
        cateName: ''
      },
      editorOption: {},
      

    };
  },
  methods: {
    onEditorBlur(){// 失去焦点事件
    }, 
    onEditorFocus(){// 获得焦点事件
    }, 
    onEditorChange(){// 内容改变事件
    },
    showFace: function (index) {
      this.faceList = this.faceTab[index].chilrens;
    },
    hoverCate: function (index) {
      this.cateList[index].show = true;
    },
    hoveroutCate: function(index) {
      this.cateList[index].show = false;
    },
    getKnowCate: function () {
      let self = this;
      let param = new FormData();
      param.set("keyword", this.cateKeyword);
   
      RequestUtils.request(conf.getKnowCate(), param).then(json => {
        for (let i=0; i<json.length; i++) {
          json[i].show = false;
        }
        self.cateList = json;
        self.selectCate(self.cateList[0]);
      })
    },
    selectCate: function (item) {
      this.keyword = '';
      this.activeCate = item;
      this.getQaList();
    },
    getMore: function () {
      this.getQaList(this.pageParam.current_page+1);
    },
    getQaList: function (page=1, $cate = true) {
      if (this.pageParam.last_page && page > this.pageParam.last_page) {
        return false;
      }
      let self = this;
      let param = new FormData();
      if ($cate) {      
        param.set("cate_id", this.activeCate.id);
      }
      param.set("keyword", this.keyword);
      param.set("page", page);

      self.qaList = [];
      this.load = 2;
      RequestUtils.request(conf.getKnowQa(), param).then(json => {
        if (page > 1) {
          for (let i=0; i<json.data.length; i++) {
            self.qaList.push(json.data[i]);
          }
        } else {
          self.qaList = json.data;        
        }
        self.load = self.qaList.length > 0 ? 3 : 1;
        self.pageParam = {
          current_page: json.current_page,
          last_page: json.last_page,
          per_page: json.per_page,
          total: json.total,
        };
      })
    },
    onCopy(item) {
      this.$copyText(item.answers).then(() => {
        this.$Message.success('已成功复制到剪切板');
      }).catch(() => {
        this.$Message.error('复制失败');
      })
    },
    addKnowledge() {
      let self = this;
      let param = new FormData();
      let content = this.$refs.answerAddElem.getEditorContent();
      param.set("cate_id", this.activeCate.id);
      param.set("questions", this.formItem.question);
      param.set("answers", content);

      if (!this.formItem.question) {
        return this.$Message.error('请输入问题');
      }

      RequestUtils.request(conf.addKnowledge(), param).then(() => {
        self.formItem.question = '';
        this.$refs.answerAddElem.clearContent();
        
        self.$Message.success('添加成功');
        self.getQaList();
      });
    },
    editKnowledge() {
      let self = this;
      let param = new FormData();
      let content = this.$refs.answerEditorElem.getEditorContent();
      param.set("id", this.editFormItem.id);
      param.set("questions", this.editFormItem.question);
      param.set("answers", content);

      if (!this.editFormItem.question) {
        return this.$Message.error('请输入问题');
      }

      RequestUtils.request(conf.editKnowledge(), param).then(() => {        
        self.$Message.success('修改成功');
        self.getQaList();
      });
    },
    editKnow: function (item) {
      this.editModal = true;
      this.editFormItem = {
        id: item.id,
        question: item.questions,
        answer: item.answers,
        cate_id: item.sku_id
      }
    },
    delKnow: function (item) {
      let self = this;
      this.$Modal.confirm({
          title: '提示',
          content: '<p>確定要刪除吗?</p>',
          onOk: () => {
            let param = new FormData();
            param.set("id", item.id);
            RequestUtils.request(conf.delKnowledge(), param).then(() => {
              
              self.$Message.success('删除成功');
              self.getQaList();
            });
          },
          onCancel: () => {
          }
      });
    },
    addCate() {
      let self = this;
      let param = new FormData();
      param.set("cateName", this.formItem.cateName);

      if (!this.formItem.cateName) {
        return this.$Message.error('请输入分类名');
      }

      RequestUtils.request(conf.addKnowledgeCate(), param).then(() => {
        self.formItem.cateName = '';
        
        self.$Message.success('添加成功');
        self.getKnowCate();
      });
    },
    editCate: function (item) {
      this.editCateModal = true;
      this.editCateFormItem = {
        id: item.id,
        cateName: item.product_sku
      }
    },
    editCateRequest: function () {
      let self = this;
      let param = new FormData();
      param.set("id", this.editCateFormItem.id);
      param.set("cateName", this.editCateFormItem.cateName);

      if (!this.editCateFormItem.cateName) {
        return this.$Message.error('请输入分类名');
      }

      RequestUtils.request(conf.editCate(), param).then(() => {        
        self.$Message.success('修改成功');
        self.getKnowCate();
      });
    },
    delCate: function (item) {
      let self = this;
      this.$Modal.confirm({
          title: '提示',
          content: '<p>確定要刪除吗?</p>',
          onOk: () => {
            let param = new FormData();
            param.set("id", item.id);
            RequestUtils.request(conf.delCate(), param).then(() => {
              
              self.$Message.success('删除成功');
              self.getKnowCate();
            });
          },
          onCancel: () => {
          }
      });
    }
  }
  
};
</script>

<style scoped lang="scss">
  .knowledge-wrap {
    min-height: 800px;

    .ivu-layout-header {
      background: #f5f7f9;
      display: flex;
      align-items: center;
    }

    .add-btn {
      width: 90%;
      border:1px dashed #999;
      border-radius: 5px;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 10px;
      background: #fff;
      cursor: pointer;
      margin: 0px auto;
    }

    .cate-tool {
      position: absolute;
      top: 12px;
      right: 5px;
    }

    .qa-wrap {
      display: flex;
      flex-direction: column;

      .label-wrap {
        font-weight: bold;
      }
      .question-val {
        color: #3c8dbc;
      }

      .tools {
        position: absolute;
        right: 0px;
        .editor-tool {

        }
        .copy-tool {
          padding-left: 10px;
        }
      }
    }
  }
</style>
